// @ts-nocheck
import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import {ErrorBoundary, useErrorBoundary} from "react-error-boundary";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {BaseButton, BaseModal} from "@/components";
import {useLogo} from "../../../util/logoUtils";

const containerCls = "flex m-4 flex-col justify-center items-center h-[50vh] text-[var(--color-warning)]";
const logoCls = "w-[var(--size-50)] mb-4 max-md:w-[150px]";
const titleCls = "text-[clamp(18px,2vw,25px)] font-normal mb-4 text-center";
const actionCls = "text-base mb-4 text-center";

const FallbackComponentRedirect = () => {
  const {resetBoundary} = useErrorBoundary();
  const [resetCalled, setResetCalled] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();
  const {t} = useTranslation();
  const logoImg = useLogo(); // Dynamic logo based on hostname

  const handleErrorState = () => {
    window.location.href = "/";
    resetBoundary();
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
      if (!resetCalled) {
        resetBoundary();
        setResetCalled(true);
      }
    }, 5000); // Redirect after 5 seconds

    const countdownTimer = setInterval(() => {
      setCountdown(c => (c > 0 ? c - 1 : 0));
    }, 1000);

    return () => {
      clearTimeout(timer);
      clearInterval(countdownTimer);
    };
  }, [navigate, resetBoundary, resetCalled]);

  return (
    <BaseModal
      open={true}
      onClose={() => {}}
      size="lg"
      closeOnOverlayClick={false}
      closeOnEscape={false}
    >
      <div className={containerCls}>
        <img
          src={logoImg}
          alt="Logo"
          className={logoCls}
        />
        <p className={titleCls}>{t("errorBoundaryRedirect1")}</p>
        <p
          className={actionCls}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "var(--space-2-5)",
          }}
        >
          <span style={{fontSize: "var(--font-h3)", textAlign: "center"}}>
            {t("errorBoundaryRedirect2")} <span style={{fontWeight: 600}}>({countdown})</span>
          </span>
        </p>
        <BaseButton
          variant="primary"
          onClick={handleErrorState}
          style={{marginTop: 30}}
        >
          {t("errorBoundaryBtnHome")}
        </BaseButton>
      </div>
    </BaseModal>
  );
};

export const ErrorBoundaryRedirect = ({children}) => {
  return <ErrorBoundary FallbackComponent={FallbackComponentRedirect}>{children}</ErrorBoundary>;
};

ErrorBoundaryRedirect.propTypes = {
  children: PropTypes.node,
};
